import pkdApi from 'store/api/pkd';

const oneRecordApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    getSearchResults : build.mutation({
      query : ({ personId, searchTerm, participantTaskId }) => ({
        url     : `../v3/app/people/${personId}/emr/providers/search/${searchTerm}?participant_task_id=${participantTaskId}`,
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
    }),
    getProviderResources : build.query({
      query : ({ personId }) => ({
        url     : `../v3/app/people/${personId}/emr/provider-resources`,
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      transformResponse : (resources) => {
        if (!Array.isArray(resources)) return {};
        return resources.reduce((prevValue, currentValue) => ({
          ...prevValue,
          [currentValue.fhirEndpointId] : { ...currentValue },
        }), {});
      },
    }),
    getAllProviders : build.query({
      query : ({ participantId, participantTaskId, getAllProvider = false }) => {
        const params = new URLSearchParams({
          'page[limit]' : 1000000,
          ...(participantTaskId && { 'filter[participant_task_id]': participantTaskId }),
          ...(getAllProvider && { 'filter[interop_vendor]': 'all' }),
        });
        return {
          url     : `../v3/people/${participantId}/providers?${params.toString()}`,
          method  : 'GET',
          headers : {
            'Content-Type' : 'application/vnd.api+json',
            Accept         : 'application/vnd.api+json',
          },
        };
      },
      // Optionally, add transformResponse if you want to normalize the response
    }),
  }),
  overrideExisting : false,
});

export const { useGetSearchResultsMutation, useGetProviderResourcesQuery, useGetAllProvidersQuery } = oneRecordApi;
